/* eslint-disable require-jsdoc */
/* eslint-disable new-cap */
/* eslint-disable prefer-promise-reject-errors */
const contentstack = require('contentstack');

// eslint-disable-next-line require-jsdoc
function detectStage(url = window.location.href) {
    const parsed = new URL(url);
    const host = parsed.hostname;
    switch (host) {
        case 'apps.dev.nuskin.io':
        case 'dev.nuskin.com':
            return 'dev';
        case 'localhost':
            return 'local';
        case 'test.nuskin.com':
            return 'test';
        case 'www.nuskin.com':
            return 'prod';
    }
}

let apiKey;
let deliveryToken;
let environment;


const stage = detectStage();

try {
    const environmentConfig = require(`../../config/${stage}.json`);
    apiKey = environmentConfig.contentstack.apiKey;
    deliveryToken = environmentConfig.contentstack.deliveryToken;
    environment = environmentConfig.contentstack.environment;
} catch (error) {
    console.error(
        `Error retrieving environment config. ${error}. Please check if the config file exists.`
    );
}

const Stack = contentstack.Stack({
    api_key: apiKey,
    delivery_token: deliveryToken,
    environment,
    region: 'us'
});


function getEntry(contentTypeUid, language) {
    const data = new Promise((resolve, reject) => {
        Stack.ContentType(contentTypeUid)
            .Query()
            .language(language)
            .includeFallback()
            .toJSON()
            .find()
            .then(
                function success(result) {
                    if (result) {
                        resolve(result[0]);
                    } else {
                        return reject('Internal Error');
                    }
                },
                function error(error) {
                    return reject(error);
                }
            );
    });
    return data;
}


export default {
    getEntry
};
